import { render } from "./ServiceDetailsSection.vue?vue&type=template&id=41c9aff6&scoped=true"
import script from "./ServiceDetailsSection.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsSection.vue?vue&type=script&lang=js"

import "./ServiceDetailsSection.vue?vue&type=style&index=0&id=41c9aff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c9aff6"]])

export default __exports__